import {
  createSalesInvoiceApi,
  getAllSalesContractApi,
  getAllSalesInvoiceBillApi,
  getSalesContractsByBuyerApi,
} from "../../../services/_sales";
import {
  salesInvoiceInitialValues,
  SalesInvoiceProducts,
  salesInvoiceProductValues,
  salesInvoiceValidationSchema,
} from "./helpers/SalesInvoiceHelper";
import moment from "moment";
import { Formik, Form, FieldArray } from "formik";
import { useNavigate } from "react-router-dom";
import { getAllChaApi } from "../../../services/_cha";
import { useCallback, useEffect, useRef, useState } from "react";
import { getAllPortsApi } from "../../../services/_port";
import BasicFields from "./sales-invoice-form/BasicFields";
import ActionFields from "./sales-invoice-form/ActionFields";
import { getBuyerNameListApi } from "../../../services/_buyer";
import ProductFields from "./sales-invoice-form/ProductFields";
import { getAllLogisticApi } from "../../../services/_logistic";
import { getAllDocumentApi } from "../../../services/_document";
import ShipmentFields from "./sales-invoice-form/ShipmentFields";
import ContainerFields from "./sales-invoice-form/ContainerFields";
import { getProductNameListApi } from "../../../services/_product";
import { errorToast, successToast } from "../../../components/Toast";
import MyDocumentsFields from "./sales-invoice-form/MyDocumentsFields";
import OtherDocumentsFields from "./sales-invoice-form/OtherDocumentsFields";
import { DocumentType } from "../../../components/Enums";
import { getAllPackingTypesApi } from "../../../services/_packingTypes";
import AddUnitModal from "../../../components/modal/AddUnit";
import AddPackingType from "../../../components/modal/AddPackingType";
import BillFields from "./sales-invoice-form/BillFields";
import { getAllSealNumberNameListApi } from "../../../services/_sealNumber";
import AddProductModal from "../../../components/modal/AddProduct";
import AddDocumentModal from "../../../components/modal/AddDocument";
import AddLogisticModal from "../../../components/modal/AddLogistics";
import AddChaModal from "../../../components/modal/AddCha";
import AddPortModal from "../../../components/modal/AddPort";
import AddBillTypeModal from "../../../components/modal/AddBillType";
import { getSettingsApi } from "../../../services/_settings";
import TotalSection from "./sales-invoice-form/TotalSection";
import {
  calculate,
  getSalesContractDetailsWithRemainingQty,
  handleSalesInvoiceCalculation,
  n,
} from "./helpers/SalesInvoiceHelperFunction";
import { getPermissions } from "../../../context/AuthContext";
import { getNotifyPartyNameListApi } from "../../../services/_notifyParty";
import AddNotifyPartyModal from "../../../components/modal/AddNotifyParty";
import AddSealNumberModal from "../../../components/modal/AddSealNumber";
import SupplierProducts from "./sales-invoice-form/SupplierProducts";
import { getSupplierNameListApi } from "../../../services/_supplier";

const CreateSalesInvoice = () => {
  const navigate = useNavigate();
  const permissions = getPermissions();
  const [noOfContainers, setNoOfContainers] = useState("");
  const [isShowContainerButton, setIsShowContainerButton] = useState(true);
  const [isShowMyDocumentButton, setIsShowMyDocumentButton] = useState(true);
  const [salesContractList, setSalesContractList] = useState([]);
  const [billList, setBillList] = useState([]);
  const [buyerList, setBuyerList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [logisticList, setLogisticList] = useState([]);
  const [chaList, setChaList] = useState([]);
  const [notifyPartyList, setNotifyPartyList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [sealNumbersList, setSealNumbersList] = useState<any[]>([]);
  const [myDocumentList, setMyDocumentList] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [initialValues] = useState<any>(salesInvoiceInitialValues);
  const [filePondDocuments, setFilePondDocuments] = useState([]);
  const [filePondBills, setFilePondBills] = useState([]);
  const [packingType, setPackingType] = useState<any[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [unitList, setUnits] = useState<any[]>([]);
  const [addUnitModalStatus, setAddUnitModalStatus] = useState(false);
  const [addPackingTypeModalStatus, setAddPackingTypeModalStatus] =
    useState(false);
  const [addProductModalStatus, setAddProductModalStatus] = useState(false);
  const [addDocumentModalStatus, setAddDocumentModalStatus] = useState(false);
  const [addLogisticModalStatus, setAddLogisticModalStatus] = useState(false);
  const [addChaModalStatus, setAddChaModalStatus] = useState(false);
  const [addNotifyPartyModalStatus, setAddNotifyPartyModalStatus] =
    useState(false);
  const [addPortModalStatus, setAddPortModalStatus] = useState(false);
  const [addBillTypeModalStatus, setAddBillTypeModalStatus] = useState(false);
  const [addSealNumberModalStatus, setAddSealNumberModalStatus] =
    useState(false);
  const [prefix, setPrefix] = useState("");

  const [salesContractData, setSalesContractData] = useState<any>([]);
  const [filteredProductList, setFilteredProductList] = useState<any[]>([]);
  const [rowPurchaseOrders, setRowPurchaseOrders] = useState<{
    [key: number]: any[];
  }>({});
  const [supplierList, setSupplierList] = useState<any[]>([]);
  const [supplierProductsQtyData, setSupplierProductsQtyData] = useState<any>(
    [],
  );
  const [remainingQtyList, setRemainingQtyList] = useState<{
    [product_id: string]: number;
  }>({});

  const [selectedSealContainer, setSelectedSealContainer] = useState<{
    productIndex: number | null;
    containerIndex: number | null;
  }>({ productIndex: null, containerIndex: null });

  const formikSetFieldValueRef = useRef<any>(null);
  const fetchInitialData = async () => {
    // const allSalesContract: any = await getAllSalesContractApi();
    // if (allSalesContract.isSuccess) {
    //   setSalesContractList(allSalesContract.data);
    // }
    const allBills: any = await getAllSalesInvoiceBillApi();
    if (allBills.isSuccess) {
      setBillList(allBills.data);
    }
    const allBuyers: any = await getBuyerNameListApi();
    if (allBuyers.isSuccess) {
      setBuyerList(allBuyers.data);
    }
    const allProducts: any = await getProductNameListApi();
    if (allProducts.isSuccess) {
      setProductList(allProducts.data);
      setFilteredProductList(allProducts.data);
    }
    const allLogistics: any = await getAllLogisticApi(`status=true`);
    if (allLogistics.isSuccess) {
      setLogisticList(allLogistics.data);
    }
    const allCha: any = await getAllChaApi(`status=true`);
    if (allCha.isSuccess) {
      setChaList(allCha.data);
    }
    const allNotifyParties: any =
      await getNotifyPartyNameListApi(`status=true`);
    if (allNotifyParties.isSuccess) {
      setNotifyPartyList(allNotifyParties.data);
    }
    const allPorts: any = await getAllPortsApi();
    if (allPorts.isSuccess) {
      setPortList(allPorts.data);
    }
    const sealNumbersList: any = await getAllSealNumberNameListApi(
      `Unused_seal_numbers=true`,
    );
    if (sealNumbersList.isSuccess) {
      setSealNumbersList(sealNumbersList.data);
    }
    const allDocuments: any = await getAllDocumentApi(`status=true`);
    if (allDocuments.isSuccess) {
      setDocumentList(allDocuments.data);
      const myDocuments = allDocuments.data.filter(
        (x: any) => x.type === DocumentType.SELF,
      );
      setMyDocumentList(myDocuments);
    }
    // const fetchUnits: any = await getAllUnitsApi();
    // if (fetchUnits.isSuccess) {
    //   setUnits(fetchUnits.data);
    // }
    const getPackingType: any = await getAllPackingTypesApi();
    if (getPackingType.isSuccess) {
      setPackingType(getPackingType.data);
    }

    const fetchSalesContractPrefix: any = await getSettingsApi();
    if (fetchSalesContractPrefix.isSuccess) {
      const { sales_invoice_prefix } = fetchSalesContractPrefix.data;
      setPrefix(sales_invoice_prefix);
    }

    const allSuppliers: any = await getSupplierNameListApi();
    if (allSuppliers.isSuccess) {
      setSupplierList(allSuppliers.data);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  const closeAddUnitModal = () => {
    setAddUnitModalStatus(false);
  };

  const closePackingTypeModal = () => {
    setAddPackingTypeModalStatus(false);
  };

  const closeAddProductModal = () => {
    setAddProductModalStatus(false);
  };

  const closeAddDocumentModal = () => {
    setAddDocumentModalStatus(false);
  };

  const closeAddLogisticModal = () => {
    setAddLogisticModalStatus(false);
  };

  const closeAddChaModal = () => {
    setAddChaModalStatus(false);
  };

  const closeAddNotifyPartyModal = () => {
    setAddNotifyPartyModalStatus(false);
  };

  const closeAddPortModal = () => {
    setAddPortModalStatus(false);
  };

  const closeAddBillTypeModal = () => {
    setAddBillTypeModalStatus(false);
  };

  const closeAddSealNumberModal = () => {
    setAddSealNumberModalStatus(false);
  };

  const getCommonValue = (contracts: any[], key: string) => {
    const values = contracts
      .map((c) => c[key])
      .filter((v) => v !== null && v !== undefined && v !== "");

    if (!values.length) return "";

    const first = values[0];

    const allSame = values.every((v) => v === first);

    return allSame ? first : "";
  };

  const handleSalesContractChange = useCallback(
    async (contractIds: string[], setFieldValue: any, values: any) => {
      if (!contractIds?.length) {
        setFilteredProductList(productList);
        setSalesContractData([]);
        setRemainingQtyList({});
        setFieldValue("sales_invoice_products", [salesInvoiceProductValues]);
        return;
      }

      let allContracts: any[] = [];
      let productRemaining: any = {};
      let productMap: any = {};
      let invoiceProducts: any[] = [];

      for (const id of contractIds) {
        const result = await getSalesContractDetailsWithRemainingQty(id);

        if (!result) continue;

        const { sales_contract, productWiseRemainingQty } = result;

        allContracts.push(sales_contract);

        sales_contract.sales_contract_product.forEach((p: any) => {
          const key = `${p.product_id}_${sales_contract.id}`;
          const remaining = productWiseRemainingQty[key];

          if (!remaining || remaining <= 0) return;

          const mapKey = `${p.product_id}_${sales_contract.id}`;

          productRemaining[mapKey] = remaining;

          productMap[mapKey] = {
            product_id: p.product_id,
            contract_id: sales_contract.id,
            contract_no: sales_contract.contract_no,
            product_name: p.products?.name,
            products: { name: p.products?.name }, // VERY IMPORTANT
          };

          const existingProduct = values.sales_invoice_products?.find(
            (prod: any) =>
              prod.product_id === p.product_id &&
              prod.sales_contract_id === sales_contract.id,
          );

          const quantity = existingProduct
            ? existingProduct.quantity
            : remaining;

          invoiceProducts.push({
            product_id: p.product_id,
            sales_contract_id: sales_contract.id,
            price: p.price,
            quantity: quantity,
            total_amount: parseFloat(p.price) * quantity,
            no_of_containers: p.no_of_containers,
            container_load: p.container_load,
            packing_type_id: p.packing_type_id,
            no_of_bags: p.no_of_bags,
            packing_net_weight: p.packing_net_weight,
            total_net_weight: calculate(
              n(p.no_of_bags) * n(p.packing_net_weight),
            ),
            packing_gross_weight: p.packing_gross_weight,
            total_gross_weight: calculate(
              n(p.no_of_bags) * n(p.packing_gross_weight),
            ),
          });
        });
      }

      const dropdownProducts = Object.values(productMap);

      setFilteredProductList(dropdownProducts);

      setSalesContractData(allContracts);

      setRemainingQtyList(productRemaining);

      // shipment background logic
      const originPort = getCommonValue(allContracts, "port_of_loading_id");
      const destinationPort = getCommonValue(allContracts, "final_destination");
      const deliveryTerm = getCommonValue(allContracts, "delivery_terms");
      const paymentTerm = getCommonValue(allContracts, "payment_terms");

      setFieldValue("origin_port_id", originPort);
      setFieldValue("destination_port", destinationPort);
      setFieldValue("delivery_term", deliveryTerm);
      setFieldValue("payment_term", paymentTerm);

      const validProductKeys = invoiceProducts.map(
        (p) => `${p.product_id}_${p.sales_contract_id}`,
      );

      const updatedContainers = (values.container || []).filter((c: any) =>
        validProductKeys.includes(`${c.product_id}_${c.sales_contract_id}`),
      );

      setFieldValue("container", updatedContainers);

      // important
      setFieldValue(
        "sales_invoice_products",
        invoiceProducts.length ? invoiceProducts : [salesInvoiceProductValues],
      );

      handleSalesInvoiceCalculation(
        "both",
        { ...values, sales_invoice_products: invoiceProducts },
        setFieldValue,
      );
    },
    [productList],
  );

  const handleBuyerChange = async (buyerId: string, setFieldValue: any) => {
    // Reset contract & products when buyer changes
    setFieldValue("sales_contract_ids", []);
    setFieldValue("sales_invoice_products", [salesInvoiceProductValues]);
    setSalesContractData([]);
    setRemainingQtyList({});
    setFilteredProductList([]);

    if (!buyerId) {
      setSalesContractList([]);
      return;
    }

    const result: any = await getSalesContractsByBuyerApi(buyerId);

    if (result?.isSuccess) {
      setSalesContractList(result.data);
    } else {
      setSalesContractList([]);
    }
  };

  // Set remaining quantity data and product data from sales contract
  const handleProductChange = (
    index: number,
    value: string,
    values: any,
    setFieldValue: any,
  ) => {
    // HANDLE CLEAR CASE
    if (!value) {
      setFieldValue(`sales_invoice_products[${index}]`, {
        ...salesInvoiceProductValues,
      });

      // also remove containers linked to this product
      const updatedContainers = (values.container || []).filter(
        (c: any, i: number) => i !== index,
      );
      setFieldValue("container", updatedContainers);

      handleSalesInvoiceCalculation("both", values, setFieldValue);
      return;
    }

    const [productId, contractId] = value.split("_");

    const contract = salesContractData.find((c: any) => c.id === contractId);

    const p = contract?.sales_contract_product?.find(
      (pr: any) => pr.product_id === productId,
    );

    if (!p) return;

    const remaining = remainingQtyList[`${productId}_${contractId}`];

    const updatedProduct = {
      product_id: productId,
      sales_contract_id: contractId,
      price: p.price,
      quantity: remaining,
      total_amount: calculate(n(p.price) * remaining),
      no_of_containers: p.no_of_containers,
      container_load: p.container_load,
      packing_type_id: p.packing_type_id,
      no_of_bags: p.no_of_bags,
      packing_net_weight: p.packing_net_weight,
      total_net_weight: calculate(n(p.no_of_bags) * n(p.packing_net_weight)),
      packing_gross_weight: p.packing_gross_weight,
      total_gross_weight: calculate(
        n(p.no_of_bags) * n(p.packing_gross_weight),
      ),
    };

    setFieldValue(`sales_invoice_products[${index}]`, updatedProduct);

    values.sales_invoice_products[index] = updatedProduct;

    handleSalesInvoiceCalculation("both", values, setFieldValue);
  };

  const handleFileChange = useCallback(
    (fileItems: any, setFieldValue: any, inputKey: string) => {
      const files = fileItems
        .map((fileItem: any) => {
          if (fileItem?.file) {
            return {
              fileName: fileItem.file.name,
              fileData: fileItem.getFileEncodeDataURL(),
            };
          }
          return null;
        })
        .filter(Boolean);
      setFieldValue(inputKey, files);
    },
    [],
  );

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const contractIds = values.sales_contract_ids || [];

    const usedContracts = (values.sales_invoice_products || []).map(
      (p: any) => p.sales_contract_id,
    );

    const unusedContracts = contractIds.filter(
      (id: string) => !usedContracts.includes(id),
    );

    // convert IDs → contract numbers
    const unusedContractNos = salesContractData
      .filter((c: any) => unusedContracts.includes(c.id))
      .map((c: any) => c.contract_no);

    if (unusedContractNos.length > 0) {
      errorToast(
        `Please add at least one product for contract ${unusedContractNos.join(", ")}`,
      );
      return;
    }
    values.invoice_date = moment(values.invoice_date).format("YYYY-MM-DD");
    values.etd = values?.etd
      ? moment(values.etd).format("YYYY-MM-DD HH:mm:ss")
      : null;
    values.eta = values?.eta
      ? moment(values.eta).format("YYYY-MM-DD HH:mm:ss")
      : null;
    values.total_amount = parseFloat(values.total_amount);
    setSubmitLoader(true);
    const result: any = await createSalesInvoiceApi(values);
    if (result.isSuccess) {
      setSubmitLoader(false);
      setIsShowContainerButton(false);
      setIsShowMyDocumentButton(false);
      successToast(result.message);
      resetForm({ values: initialValues });
      navigate(`/sales-invoice-list`);
    } else {
      setSubmitLoader(false);
      errorToast(result.message);
    }
    return;
  };

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>Create Commercial Invoice</h5>
          </div>
        </div>
        <div className="card-body">
          <Formik
            enableReinitialize
            initialValues={{
              ...initialValues,
              invoice_no: prefix || "",
            }}
            validationSchema={salesInvoiceValidationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              handleChange,
              setFieldValue,
              errors,
              touched,
              resetForm,
              setFieldError,
            }) => {
              formikSetFieldValueRef.current = setFieldValue;
              return (
                <Form className="dt_adv_search">
                  <div className="row g-3">
                    <BasicFields
                      salesContractList={salesContractList}
                      buyerList={buyerList}
                      logisticList={logisticList}
                      chaList={chaList}
                      notifyPartyList={notifyPartyList}
                      setAddLogisticModalStatus={setAddLogisticModalStatus}
                      setAddChaModalStatus={setAddChaModalStatus}
                      setAddNotifyPartyModalStatus={
                        setAddNotifyPartyModalStatus
                      }
                      values={values}
                      setFieldValue={setFieldValue}
                      resetForm={resetForm}
                      handleChange={handleChange}
                      handleSalesContractChange={handleSalesContractChange}
                      handleBuyerChange={handleBuyerChange}
                      permissions={permissions}
                    />

                    <div>
                      <label
                        htmlFor="products"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Add Products: <span className="text-danger">*</span>
                      </label>
                      <div>
                        <FieldArray name="sales_invoice_products">
                          {({ remove }) => (
                            <>
                              {(values.sales_invoice_products ?? []).map(
                                (item: SalesInvoiceProducts, index: number) => (
                                  <ProductFields
                                    key={index}
                                    index={index}
                                    item={item}
                                    remove={remove}
                                    unitList={unitList}
                                    productList={filteredProductList}
                                    packingType={packingType}
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    handleChange={handleChange}
                                    setAddUnitModalStatus={
                                      setAddUnitModalStatus
                                    }
                                    setAddPackingTypeModalStatus={
                                      setAddPackingTypeModalStatus
                                    }
                                    setAddProductModalStatus={
                                      setAddProductModalStatus
                                    }
                                    handleProductChange={handleProductChange}
                                    remainingQtyList={remainingQtyList}
                                    setFieldError={setFieldError}
                                    errors={errors}
                                    permissions={permissions}
                                  />
                                ),
                              )}
                              <div className="row mb-1 g-1 px- col-12 col-sm-6 col-lg-3">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => {
                                    const newItems = [
                                      ...values.sales_invoice_products,
                                      { ...salesInvoiceProductValues },
                                    ];
                                    setFieldValue(
                                      "sales_invoice_products",
                                      newItems,
                                    );
                                  }}
                                >
                                  Add Product
                                </button>
                              </div>
                            </>
                          )}
                        </FieldArray>

                        {errors.sales_invoice_products &&
                          touched.sales_invoice_products &&
                          typeof errors.sales_invoice_products === "string" && (
                            <div className="text-danger">
                              {errors.sales_invoice_products}
                            </div>
                          )}
                      </div>
                    </div>

                    <TotalSection
                      values={values}
                      setFieldValue={setFieldValue}
                    />

                    {/* <PackingFields
                      unitList={unitList}
                      packingType={packingType}
                      values={values}
                      handleChange={handleChange}
                      setAddUnitModalStatus={setAddUnitModalStatus}
                      setAddPackingTypeModalStatus={
                        setAddPackingTypeModalStatus
                      }
                      setFieldValue={setFieldValue}
                      calculateWeight={calculateWeight}
                    /> */}

                    <ShipmentFields
                      portList={portList}
                      setAddPortModalStatus={setAddPortModalStatus}
                      values={values}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      permissions={permissions}
                    />

                    <ContainerFields
                      productList={filteredProductList}
                      permissions={permissions}
                      setAddProductModalStatus={setAddProductModalStatus}
                      setAddSealNumberModalStatus={setAddSealNumberModalStatus}
                      setSelectedSealContainer={setSelectedSealContainer}
                      setFieldValue={setFieldValue}
                      sealNumbersList={sealNumbersList}
                      values={values}
                      noOfContainers={noOfContainers}
                      setNoOfContainers={setNoOfContainers}
                      isShowContainerButton={isShowContainerButton}
                      handleChange={handleChange}
                      setIsShowContainerButton={setIsShowContainerButton}
                    />

                    <MyDocumentsFields
                      documentList={documentList}
                      myDocumentList={myDocumentList}
                      isShowMyDocumentButton={isShowMyDocumentButton}
                      setIsShowMyDocumentButton={setIsShowMyDocumentButton}
                      values={values}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />

                    <OtherDocumentsFields
                      actionType={"create"}
                      values={values}
                      documentList={documentList}
                      filePondDocuments={filePondDocuments}
                      setAddDocumentModalStatus={setAddDocumentModalStatus}
                      setFilePondDocuments={setFilePondDocuments}
                      handleFileChange={handleFileChange}
                      setFieldValue={setFieldValue}
                      permissions={permissions}
                    />

                    <BillFields
                      actionType={"create"}
                      values={values}
                      billList={billList}
                      filePondBills={filePondBills}
                      setAddBillTypeModalStatus={setAddBillTypeModalStatus}
                      setFilePondBills={setFilePondBills}
                      handleFileChange={handleFileChange}
                      setFieldValue={setFieldValue}
                    />

                    <SupplierProducts
                      values={values}
                      productList={productList}
                      rowPurchaseOrders={rowPurchaseOrders}
                      setRowPurchaseOrders={setRowPurchaseOrders}
                      supplierList={supplierList}
                      setSupplierList={setSupplierList}
                      supplierProductsQtyData={supplierProductsQtyData}
                      setSupplierProductsQtyData={setSupplierProductsQtyData}
                      unitList={unitList}
                      setFieldValue={setFieldValue}
                      setFieldError={setFieldError}
                      errors={errors}
                    />

                    <ActionFields submitLoader={submitLoader} />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
      <AddUnitModal
        addUnitModalStatus={addUnitModalStatus}
        closeAddUnitModal={closeAddUnitModal}
        onUnitCreated={fetchInitialData}
      />
      <AddPackingType
        addPackingTypeModalStatus={addPackingTypeModalStatus}
        closePackingTypeModal={closePackingTypeModal}
        onPackingTypeCreated={fetchInitialData}
      />
      <AddProductModal
        addProductModalStatus={addProductModalStatus}
        closeAddProductModal={closeAddProductModal}
        onProductCreated={fetchInitialData}
      />
      <AddDocumentModal
        addDocumentModal={addDocumentModalStatus}
        closeAddDocumentModal={closeAddDocumentModal}
        onDocumentCreated={fetchInitialData}
      />
      <AddLogisticModal
        addLogisticModalStatus={addLogisticModalStatus}
        closeAddLogisticModal={closeAddLogisticModal}
        onLogisticCreated={fetchInitialData}
      />
      <AddChaModal
        addChaModalStatus={addChaModalStatus}
        closeAddChaModal={closeAddChaModal}
        onChaCreated={fetchInitialData}
      />
      <AddNotifyPartyModal
        addNotifyPartyModalStatus={addNotifyPartyModalStatus}
        closeAddNotifyPartyModal={closeAddNotifyPartyModal}
        onNotifyPartyCreated={fetchInitialData}
      />
      <AddPortModal
        addPortModal={addPortModalStatus}
        closeAddPortModal={closeAddPortModal}
        onPortCreated={fetchInitialData}
      />
      <AddBillTypeModal
        addBillTypeModal={addBillTypeModalStatus}
        closeBillTypeModal={closeAddBillTypeModal}
        onBillTypeCreated={fetchInitialData}
      />
      <AddSealNumberModal
        addSealNumberModalStatus={addSealNumberModalStatus}
        closeSealNumberModal={closeAddSealNumberModal}
        onSealNumberCreated={async (newSealNumbers: any) => {
          setSealNumbersList((prev) => [...prev, ...newSealNumbers]);

          if (
            selectedSealContainer.productIndex !== null &&
            selectedSealContainer.containerIndex !== null
          ) {
            await new Promise((r) => setTimeout(r, 0)); // ensures re-render timing
            formikSetFieldValueRef.current?.(
              `container[${selectedSealContainer.containerIndex}].self_seal_id`,
              newSealNumbers[0]?.id,
            );
            setSelectedSealContainer({
              productIndex: null,
              containerIndex: null,
            });
          }
        }}
      />
    </>
  );
};

export default CreateSalesInvoice;
